export default "<div class=\"skeleton\"></div>"